import React from 'react';
import { Checkbox, Grid, Header } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { datasetSubscriptions } from '@/notifications/subscribers/constants';
import Events from '../hooks/events';

const DatasetSubscribeCard = ({ code, disabled, subscribed }) => {
  const intl = useIntl();
  const toggleSubscribed = Events.useToggleDatasetSubscribe(datasetSubscriptions.DATASET_UPDATE, { code });
  const suffix = subscribed ? 'subscribed' : 'not.subscribed';
  const title = `dataset.subscriptions.${datasetSubscriptions.DATASET_UPDATE}.header.${suffix}`;
  const text = `dataset.subscriptions.${datasetSubscriptions.DATASET_UPDATE}.content.${suffix}`;

  return (
    <Grid>
      <Grid.Column>
        <Header as="h4"><FormattedMessage id={title} /></Header>
        <Grid.Row><FormattedMessage id={text} /></Grid.Row>
        <Grid.Row>
          <Checkbox
            toggle
            checked={subscribed}
            label={intl.formatMessage({ id: `dataset.subscriptions.${datasetSubscriptions.DATASET_UPDATE}.subscribe` })}
            onClick={disabled ? undefined : () => toggleSubscribed()}
            disabled={disabled}
          />
        </Grid.Row>
      </Grid.Column>
    </Grid>
  );
};

export default DatasetSubscribeCard;
